export default "__VITE_ASSET__Byk2iZKn__"